import { hasPermission } from "../modules/rbac/permission-manifest";

const associateMenu = (associate) => {
  return [
    {
      title: "Dashboard",
      icon: "dashboard",
      path: "AssociateDashboard",
      children: [],
      visible: true,
    },
    {
      title: "Orders",
      icon: "shopping_cart",
      path: "AssociateOrders",
      children: [],
      visible: hasPermission("canCreateOrder", null, associate),
    },
    {
      title: "Customers",
      icon: "domain",
      path: "Customers",
      children: [],
      visible: hasPermission("canReadCustomer", null, associate),
    },
    {
      title: "Templates",
      icon: "file_copy",
      path: "AssociateTemplates",
      children: [],
      visible: true,
    },
    {
      title: "Product Management",
      icon: "local_offer",
      path: "ProductManagement",
      children: [],
      visible: hasPermission("canReadProduct", null, associate),
    },
    {
      title: "Distributors",
      icon: "local_shipping",
      path: "Distributors",
      children: [],
      visible: hasPermission("canReadDistributor", null, associate),
    },
  ];
};

const userMenu = (user) => {
  return [
    {
      title: "Dashboard",
      icon: "dashboard",
      path: "Dashboard",
      children: [],
      visible: true,
    },
    {
      title: "Orders",
      icon: "shopping_cart",
      path: "UserOrders",
      children: [],
      visible: true,
    },
    {
      title: "Templates",
      icon: "file_copy",
      path: "UserTemplates",
      children: [],
      visible: true,
    },
  ];
};

export { associateMenu, userMenu };
